/*
import {
  hf,
  ht,
  cr,
  gs,
  ls,
} from 'lib';
*/
import * as cr from './_cr';
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state

import * as icm from './icm';

import * as Iccv20 from './icvBaseS10Rz';

import * as Iccv03b1 from './icvI15S10To';
import * as Iccv03b2 from './icvI15S10Co';

export const N = (pz: {
}) => {

  const _gUserz = gs.useUserz();

  const _sPz = ls.usePagez({
    steps: [0],
    phs: 'dpy',
    lblz: icm.grtLblz({
      tgt: '団体種別',
    })
  });

  icm.loadAtTopAsync({
    _31r_fst: _gUserz.crt._31rz?._fst,
    frcUdt: _sPz.udtAll,
  });

//hf.l(`icvI15S10Co 32: here`)
  return (
    cr.c(Iccv20.N, {
      key: -10,
      cz: {
        pageName: 
          _sPz.crt.steps[0] == 0 ?
            _sPz.crt.lblz.ttlz.top
          : _sPz.crt.steps[0] == 1 ?
            _sPz.crt.lblz.ttlz.ctt
          : ''
      },
      oClds: [

        _sPz.crt.steps[0] == 0 ?
        cr.c(Iccv03b1.N, {
          key: -10,
          sPz: _sPz,
          cz: {
            mode: 'r',
          }
        })
        : null,

        _sPz.crt.steps[0] == 1 ?
        cr.c(Iccv03b2.N, {
          key: -20,
          sPz: _sPz,
          cz: {
            mode: 'r',
          }
        })
        : null,

      ]
    })
  );
};
